import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import '@telegram-apps/telegram-ui/dist/styles.css';
import InitApp from './InitApp';
import reportWebVitals from './reportWebVitals';
import './scripts/i18n.tsx';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <InitApp />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
